import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'busySignal',
    standalone: true
})
export class BusySignalPipe implements PipeTransform {
    transform(value: string, isBusy: boolean, busyPlaceholder: string = 'busy'): string {
        return isBusy === true ? busyPlaceholder : value;
    }
}
